import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

const DEFAULT_MAX_VALUE = 100;

@Component({
  selector: 'z-disk-capacity-field',
  templateUrl: './disk-capacity-field.component.html',
  styleUrls: [ './disk-capacity-field.component.scss' ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DiskCapacityFieldComponent),
      multi: true
    }
  ]
})
export class DiskCapacityFieldComponent implements ControlValueAccessor {
  @Input()
  label: string;

  @Input()
  step = 1;

  @Input()
  unit = 'GB';

  @Input()
  minValue = 1;

  @Input()
  set maxValue(v: number | undefined) {
    this._maxValue = v ?? DEFAULT_MAX_VALUE;
  }
  get maxValue() {
    return this._maxValue;
  }

  @Input()
  labelTranslation: string;

  // a current value above the maximum (e.g. the limit was lowered) must stay visible on the slider
  get sliderMaxValue() {
    return Math.max(this.maxValue, this.value ?? 0);
  }

  set value(v) {
    this._value = v;

    this._propagateChange(this.value);
  }

  get value() {
    return this._value;
  }

  private _value: number;
  private _maxValue = DEFAULT_MAX_VALUE;

  writeValue(val: number) {
    this.value = val;
  }

  registerOnChange(fn: any) {
    this._propagateChange = fn;
  }

  registerOnTouched(_: any) {
    return;
  }

  private _propagateChange = (_: any) => {
    return;
  };
}
